export default __webpack_public_path__ + "static/media/thumbnail_funnel_3.934c9149.png";